$shm_hitalama_map_touch $mol_touch
